<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p class="textcenter">In remembrance of a pioneer’s daughter,</p>
<p class="textcenter">loving mother</p>
<p class="textcenter">and grandmother.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?7b8013d8